import React from "react";
import Footer from "../../Components/Shared/FooterOne/Footer";
import Navbar from "../../Components/Shared/NavbarOne/Navbar";
import StationTracker from "../../Components/StationPageComponents/StationTracker/StationTracker";
import Subscription from "../../Components/StationPageComponents/Subscription/Subscription";

function Sation() {
  return (
    <div className="bg-navyDark">
      <div className="py-8 px-6 sm:px-12 md:px-16 lg:px-20">
        <div className="max-w-[1180px] mx-auto">
          <Navbar></Navbar>
        </div>
      </div>
      <main>
        <StationTracker></StationTracker>
        <Subscription></Subscription>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default Sation;
